<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="待办事项" :header-visible="true" :back-visible="true" /><!--参数都可以不传-->
    <scroll-refresh>
      <div class="tools-wrap">
        <div class="menu-dev" @click="clickTab">
          <el-radio-group v-model="tab">
            <el-radio-button label="待处理资源"></el-radio-button>
            <el-radio-button label="待办任务"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="tab-content tab-content1" v-show="tab === '待办任务'">
          <div class="form-tools">
            <jm-dict-select
              @change="changeTab"
              dict="dataset.visit.tkPass"
              v-model="form1.tk_pass"
            />
            <el-select
              v-model="form1.tk_type"
              @change="changeTab"
              placeholder="请选择">
              <el-option
                label="全部"
                value=""/>
              <el-option
                v-for="item in options.type"
                :key="item.key"
                :label="item.value"
                :value="item.key"/>
            </el-select>
            <el-select
              v-model="form1.searchType"
              @change="changeTab"
              placeholder="请选择">
              <el-option label="今天" value="today"/>
              <el-option label="明日" value="+1day"/>
              <el-option label="后日" value="+2day"/>
              <el-option label="7日内" value="+7day"/>
              <el-option label="全部" value=""/>
            </el-select>
            <!--            <jm-dict-select-->
            <!--              @change="changeTab"-->
            <!--              data-stype="2"-->
            <!--              dict="dataset.visit.searchType"-->
            <!--              v-model="form1.searchType"-->
            <!--            />-->
          </div>
          <div class="task-content">
            <data-list url="/index/Plantask/index"
                       :search-data="form1"
                       :refresh.sync="refresh">
              <template slot-scope="{ item }">
                <div class="item">
                  <p>
                    <span :class="`tk-type tk-type-${item.tk_type_key}`">{{ item.tk_type }}</span>
                    <span class="tk-date">{{ item.tk_time }}</span>
                    <span class="tk-status-right" v-if="item.tk_pass_str === '待处理'">
                      <el-select v-model="item.tk_pass"
                                 @change="departmentChangePass(item)"
                                 placeholder="请选择">
                        <el-option
                          label="待处理"
                          :value="0">
                        </el-option>
                        <el-option
                          label="已处理"
                          :value="1">
                        </el-option>
                        <el-option
                          label="已取消"
                          :value="2">
                        </el-option>
                      </el-select>
                    </span>
                    <span class="tk-status-right" v-else>{{ item.tk_pass_str }}</span>
                  </p>
                  <p style="display: flex; justify-content: space-between">
                    <span class="tk-memo-title">备注</span>
                    <span class="tk-memo-content">{{ item.tk_memo }}</span>
                  </p>
                  <p><span class="tk-title">{{ item.tk_name }}</span></p>
                  <p class="btn-area">
                    <router-link v-if="item.crm_id" :to="{ name: 'h5User', params: { crmid: item.crm_id } }"><el-button>用户详情</el-button></router-link>
                    <el-button v-if="item.crm_id" @click="showPopup(item.crm_id)">快速回访</el-button>
                    <el-button v-show="item.tk_pass_str === '待处理'" @click="showPopupPlantask(item)">编辑</el-button>
                  </p>
                </div>
              </template>
            </data-list>
          </div>
        </div>
        <div v-show="tab === '待处理资源'">
          <div class="form-student-tools">
            <el-radio-group class="first-level-tab" v-model="tab2" @change="changeTab2">
              <div class="moreuser-select" v-if="$hasPermission([1, 22, 33, 36, 39, 42, 51, 101, 121, 122, 142, 148])">
                <el-select v-model="form2.searchTeacher" @change="changeStudentType" placeholder="全部员工" clearable>
                  <el-option
                    v-for="item in options.teachers"
                    :key="item.key"
                    :label="item.name"
                    :value="item.key"/>
                </el-select>
              </div>
              <el-radio-button v-for="item in dict.formType2" :key="item.value"
                               :label="item.value">{{ item.title }}
              </el-radio-button>
            </el-radio-group>
            <el-radio-group class="second-level-tab" v-model="tab3" @change="changeStudentType">
              <el-radio-button v-for="item in formType3" :key="item.value" v-show="formType3.length > 1"
                               :label="item.value">{{ item.title }}
              </el-radio-button>
            </el-radio-group>
            <data-list url="/index/Plantask/students"
                       :search-data="form2"
                       :refresh.sync="refresh1"
                       :refresh-lock="refreshLock1">
              <template slot-scope="{ item, header, refresh }">
                <div class="student">
                  <student-card :item="item" :header="header" :refresh.sync="refresh"></student-card>
                  <div class="plantask-btn-content">
                    <router-link :to="{ name: 'h5User', params: { crmid: item.id } }">
                      <el-button state-key="fib.jiemo.net/h5/plantask/studentCard-查看" :state-status="true">查看</el-button>
                    </router-link>
                    <router-link :to="{ name: 'h5EditUser', params: { crmid: item.id } }">
                      <el-button state-key="fib.jiemo.net/h5/plantask/studentCard-编辑" :state-status="true">编辑</el-button>
                    </router-link>
                    <el-button @click="showPopup(item.id)" state-key="fib.jiemo.net/h5/plantask/studentCard-快速回访" :state-status="true">快速回访</el-button>
                    <!-- <el-button @click="showFinancial({ type: 2, crm_id: item.id })" state-key="fib.jiemo.net/h5/plantask/studentCard-财务报账" :state-status="true">财务报账</el-button> -->
                  </div>
                </div>
              </template>
            </data-list>
          </div>
        </div>
      </div>
    </scroll-refresh>
    <el-button
      class="edit-fixed"
      type="primary"
      size="mini"
      @click="showPopupPlantask()"
      state-key="fib.jiemo.net/h5/plantask/fixed-添加任务"
      :state-status="true"
    >添加<br/>任务</el-button>
    <popup-returnvisit :show-lock="returnVisitLock" :crm_id="this.visitForm.crmid">
      <el-button slot="close-button" @click="closePopup" class="btn-close-popup"><font>×</font></el-button>
    </popup-returnvisit>
    <popup-plantask :show-lock.sync="plantaskLock" :task-form="taskForm" :options="options.type">
      <el-button slot="close-button" @click="closePopupPlantask" class="btn-close-popup"><font>×</font></el-button>
    </popup-plantask>
    <popup-financial :show-lock.sync="financialLock" :financial-form="financialForm">
      <el-button slot="close-button" @click="closeFinancial" class="btn-close-popup"><font>×</font></el-button>
    </popup-financial>
  </div>
</template>
<script>
import header from './compoments/header';
import scrollRefresh from './compoments/scrollRefresh';
import DataList from './compoments/dataList';
import popupReturnVisit from './compoments/popupReturnVisit';
import popupPlantask from './compoments/popupPlantask';
import popupFinancial from './compoments/popupFinancial';
import StudentCard from './compoments/studentCard';
import plantaskDict from './plantaskDict';

let task = {
  tk_time: new Date(),
  tk_type: 1,
  tk_name: '',
  tk_memo: '',
  tk_create: '',
};

let financial = {
  crm_id: 0,
};

export default {
  mixins: [plantaskDict],
  data() {
    return {
      tab: '待处理资源',
      tab2: 'visit',
      tab3: 'visit-1',
      formType3: '',
      refresh: false,
      refresh1: false,
      refreshLock1: true,
      form1: {
        tk_pass: -1,
        tk_type: '',
        searchType: 'today',
        searchTeacher: ''
      },
      form2: {
        searchType: 'visit-1',
        searchTeacher: ''
      },
      taskForm: task,
      taskFormShow: false,
      visitForm: {
        crmid: 0,
      },
      financialForm: financial,
      options: [],
      list: [],
      returnVisitLock: false,
      plantaskLock: false,
      financialLock: false,
    };
  },
  computed: {
  },
  methods: {
    fetchData() {
      this.$http
        ._get({
          url: '/index/plantask/plantaskInterface'
        })
        .then(({ data }) => {
          this.options = data;
          this.refresh1 = true;
          this.refreshLock1 = false;
        });
    },
    changeTab() {
      this.refresh = true;
    },
    changeTab2() {
      this.formType3 = this.dict.formType3[this.tab2];
      this.tab3 = this.formType3[0].value;
      this.changeStudentType();
    },
    changeStudentType() {
      this.form2 = Object.assign({}, this.form2, { searchType: this.tab3 });
      this.refresh1 = true;
    },
    clickTab() {
      if (this.tab !== '待办任务') {
        this.changeTab();
      } else {
        this.changeStudentType();
      }
    },
    addtask(data = {}) {
      this.taskForm = Object.assign({}, task, data);
      this.taskFormShow = true;
    },
    // 关闭预约回访弹窗
    closePopup: function() {
      this.returnVisitLock = false;
    },
    showPopup(id) {
      this.visitForm.crmid = id;
      this.returnVisitLock = true;
    },
    // 关闭计划任务弹窗
    closePopupPlantask: function() {
      this.plantaskLock = false;
    },
    // 打开计划任务弹窗
    showPopupPlantask: function(taskData = {}) {
      this.taskForm = Object.assign({}, task, taskData);
      this.plantaskLock = true;
    },
    // 打开财务报账或支付邀约
    showFinancial(data) {
      this.financialForm = Object.assign({}, financial, data);
      this.financialLock = true;
    },
    // 关闭财务报账或支付邀约
    closeFinancial() {
      this.financialLock = false;
    },
    departmentChangePass(row) {
      this.$confirm('确认处理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          ._post({
            url: '/index/plantask/editPlan',
            data: {
              tk_id: row.tk_id,
              tk_pass: row.tk_pass
            }
          })
          .then(() => {
            this.refresh = true;
            this.$message({
              type: 'success',
              message: '处理成功!'
            });
          });
      }).catch(() => {
        row.tk_pass = 0;
        this.$message({
          type: 'info',
          message: '已取消处理'
        });
      });
    },
  },
  watch: {
    plantaskLock() {
      if (!this.plantaskLock) {
        this.changeTab();
        this.taskForm = task;
      }
    },
  },
  mounted() {
    this.fetchData();
    this.$nextTick(() => {
      this.formType3 = this.dict.formType3.visit;
    });
  },
  components: {
    'wap-header': header,
    'data-list': DataList,
    'student-card': StudentCard,
    'popup-returnvisit': popupReturnVisit,
    'popup-plantask': popupPlantask,
    popupFinancial,
    scrollRefresh
  }
};
</script>
<style>
  .menu-dev .el-radio-group .el-radio-button .el-radio-button__inner{
    width: 46vw;
    color: #0496ff;
    border-color: #0496ff;
  }
  .menu-dev .el-radio-group .el-radio-button.is-active .el-radio-button__inner{
    color: #fff;
    background: #0496ff;
  }
  .tools-wrap.active{
    pointer-events: none;
  }
  .tools-wrap .tab-content1 .form-tools .el-select{
    width: 28vw;
  }
  .tools-wrap .tab-content1 .form-tools .el-select .el-input__inner{
    border: none;
    color: #0496ff;
  }
  .tools-wrap .tab-content1 .form-tools .el-select .el-input .el-select__caret{
    color: #0496ff;
  }
  .form-student-tools .first-level-tab{
    display: flex;
    justify-content: flex-start;
    background: #fff;
    padding: 0 8vw;
    line-height: 12.2vw;
    white-space: nowrap;
    overflow-x: auto;
    box-shadow: 0 0.5vw 0.5vw rgba(224,224,224,.25);
  }
  .form-student-tools .first-level-tab .el-radio-button .el-radio-button__inner{
    background: none;
    border: none;
    border-radius: 0;
    padding: 0;
    line-height: 12vw;
    border-bottom: 0.8vw solid transparent;
    box-shadow: none;
    margin-right: 8vw;
    font-size: 3.7vw;
  }
  .form-student-tools .first-level-tab .el-radio-button.is-active .el-radio-button__inner{
    color: #0496ff;
    line-height: 12vw;
    border-bottom: 0.8vw solid #0496ff;
    box-shadow: none;
  }
  .form-student-tools .first-level-tab{
    padding: 0 4vw;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    display: block;
  }
  .form-student-tools .first-level-tab .moreuser-select{
    display: inline-block;
    vertical-align: middle;
    padding-right: 3vw;
    margin-right: 3vw;
    border-right: 1px solid #dedede;
    line-height: normal;
    border-bottom: 0.8vw solid transparent;
  }
  .form-student-tools .first-level-tab .moreuser-select .el-select{
    width: 18vw;
  }
  .form-student-tools .first-level-tab .moreuser-select .el-select .el-input__inner{
    height: auto;
    line-height: 6.4vw;
    background: none;
    padding: 0;
    font-size: 3.7vw;
    font-weight: bold;
    border-radius: 0;
    border: none;
    color: #0496ff;
  }
  .form-student-tools .first-level-tab .moreuser-select .el-select .el-input__inner::placeholder{
    color: #0496ff;
  }
  .form-student-tools .first-level-tab .moreuser-select .el-select .el-input .el-select__caret{
    font-family: "微软雅黑", Microsoft Yahei !important;
    font-size: 0;
    width: 0;
    height: 0;
    overflow: hidden;
    border-top: 1vw solid #0496ff;
    border-left: 0.8vw solid transparent;
    border-right: 0.8vw solid transparent;
    transform: translateY(-50%);
    top: 50%;
    position: absolute;
  }
  .form-student-tools .second-level-tab{
    padding: 4vw;
    display: flex;
    justify-content: space-around;
  }
  .form-student-tools .second-level-tab .el-radio-button .el-radio-button__inner{
    background: #ededed;
    border: none;
    height: 6.4vw;
    line-height: 6.4vw;
    border-radius: 3.2vw;
    padding: 0 2.6vw;
    margin-right: 2.6vw;
    color: #666;
    font-size: 3.73vw;
    font-weight: 400;
    box-shadow: none;
  }
  .form-student-tools .second-level-tab .el-radio-button.is-active .el-radio-button__inner{
    background: #E0F2FF;
    color: #0496ff;
  }
  .task-content .item .tk-status-right .el-select{
    top: -2vw;
  }
  .task-content .item .tk-status-right .el-select .el-input__inner{
    padding: 0;
    border: none;
    color: #FF9736;
    width: 19vw;
  }
</style>
<style scoped>
  /*顶部菜单*/
  .menu-dev {
    width: 100%;
    text-align: center;
    background: #fff;
  }
  .menu-dev .el-radio-group {
    width: 100%;
    cursor: pointer;
  }
  .menu-dev .el-radio-group .el-radio-button{
    outline: none;
  }
  .menu-dev .el-radio-group .el-radio-button__inner {
    width: 46vw;
    display: inline-block;
  }

  .tab-content1 .form-tools{
    display: flex;
    justify-content: space-around;
    background: #fff;
    padding: 1vw 8vw;
    margin-bottom: 3vw;
  }

  /*待办任务列表*/
  .task-content {
    text-align: center;
  }
  .item {
    width: 100%;
    margin: 0vw;
    padding: 0 0 4vw;
    text-align: left;
    background: #FFF;
    border-radius: 11px;
    display: block;
  }
  .item p {
    padding: 2vw 0;
    width: 100%;
  }
  .item .btn-area{
    display: flex;
    justify-content: flex-end;
    border-top: 0.7px solid #CFCFCF;
    padding-top: 4vw;
    padding-bottom: 1vw;
  }
  .item .btn-area .el-button{
    padding: 0 2vw;
    height: 8vw;
    line-height: 8vw;
    border-radius: 4vw;
    margin-right: 1.5vw;
    margin-left: 0;
    border: 0.7px solid #bababa;
  }
  .item .tk-type {
    font-style: normal;
    font-weight: normal;
    font-size: 3.46vw;
    line-height: 4.26vw;
    align-items: center;
    text-align: center;
    display: inline-block;
    border: 0.5px solid;
    box-sizing: border-box;
    border-radius: 0.5vw;
    padding: 0.5vw 1vw;
  }
  .item .tk-type-1 {
    color: #24BC85;
    border-color: #24BC85;
  }
  .item .tk-type-2 {
    color: #0496FF;
    border-color: #0496FF;
  }
  .item .tk-type-3 {
    color: #6631FF;
    border-color: #6631FF;
  }
  .item .tk-type-4 {
    color: #FF124B;
    border-color: #FF124B;
  }
  .item .tk-date {
    font-style: normal;
    font-weight: 600;
    font-size: 4vw;
    line-height: 3.73vw;
    padding-left: 3vw;
    display: inline-block;
  }

  .item .tk-status-right {
    float: right;
    font-style: normal;
    font-weight: normal;
    font-size: 3.73vw;
    line-height: 5.3vw;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FF9736;
  }

  .item .tk-memo-title {
    font-style: normal;
    font-weight: normal;
    font-size: 4vw;
    line-height: 7.6vw;
    width: 12vw;
    color: #A8AFC9;
    display: inline-block;
    vertical-align: top;
    white-space: nowrap;
  }
  .item .tk-memo-content {
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    width: 82vw;
    height: 16vw;
    padding: 1.2vw 4vw;
    background: #F1F5FC;
    border-radius: 1.6vw;
    font-style: normal;
    font-weight: normal;
    font-size: 4vw;
    line-height: 5.4vw;
    color: #8F99BF;
  }
  .item .tk-title {
    display: block;
    margin: 1vw 0;
    font-style: normal;
    font-weight: normal;
    font-size: 4vw;
    line-height: 5.4vw;
    color: #A8AFC9;
  }
  .item .el-button {
    background: #FFFFFF;
    border: 0.5px solid #BABABA;
    box-sizing: border-box;
    border-radius: 5vw;
    font-style: normal;
    font-weight: normal;
    font-size: 3.73vw;
    line-height: 5.3vw;
    color: #333333;
  }

  /* 添加按钮 */
  .edit-fixed {
    position: fixed;
    right: 4vw;
    bottom: 24vw;
    width: 14vw;
    height: 14vw;
    padding: 0;
    border-radius: 50%;
    text-align: center;
    z-index: 19;
    line-height: 4vw;
    font-size: 3vw;
  }
  .plantask-btn-content{
    border-top: 0.5px solid #cfcfcf;
    margin-top: 3.3vw;
    padding: 3vw 0;
    text-align: right;
  }
  .plantask-btn-content .el-button{
    font-size: 3.73vw;
    padding: 0;
    height: 8vw;
    line-height: 8vw;
    width: 20.2vw;
    margin-left: 2vw;
    border-radius: 4vw;
    border:0.7px solid #bababa ;
  }
</style>
